import {
  AttachmentVisibilityMessageModified,
  SocketData,
} from 'actions/socket/socketReceiveDataAction'

import { ChatMessengerState } from '../ChatMessengerState'

export const updateAttachmentVisibilityMessageModified = (
  socketData: SocketData<AttachmentVisibilityMessageModified>,
  chatState: ChatMessengerState
): ChatMessengerState => {
  const { isVisible, contactId, messageId } = socketData.content

  if (chatState.chatData.contactId !== contactId) {
    return chatState
  }

  const { photosRestrictionStatus } = chatState

  photosRestrictionStatus?.noRestrictionForMessagesWithIds

  const _noRestrictionForMessagesWithIds = isVisible
    ? [...photosRestrictionStatus?.noRestrictionForMessagesWithIds!, messageId]
    : photosRestrictionStatus?.noRestrictionForMessagesWithIds.filter(
        (_messageId) => _messageId !== messageId
      )!

  return {
    ...chatState,
    photosRestrictionStatus: {
      ...chatState.photosRestrictionStatus!,
      noRestrictionForMessagesWithIds: _noRestrictionForMessagesWithIds,
    },
  }
}
